module.exports = __webpack_public_path__ + "img/FH_logo.a8766a1a.png";